import clsx from 'clsx';
import { IllustratedMagnifyingGlass } from '@hungryroot/icons';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './LookingForMore.module.css';

type Props = {
  className?: string;
};

export function LookingForMore({ className }: Props) {
  return (
    <div className={clsx(styles.container, className)}>
      <IllustratedMagnifyingGlass className={styles.icon} />
      <Heading variant="H3" className={styles.title}>
        Looking for more? Don’t worry!
      </Heading>
      <Paragraph className={styles.subtitle}>
        Your selections help us learn your tastes. Browse our full catalog after
        checkout.
      </Paragraph>
    </div>
  );
}
